
import { Image, useScroll } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import { mainStore } from "../../store"


export default function Garage(props)
{

    const group = useRef()

    const data = useScroll()

    const colors = mainStore.useStore(s => s.colors)
    


    useFrame(() => {
        group.current.children[0].position.z = 0 - data.range(0, 1 / 3) / 2
        group.current.children[1].position.z = -0.55 - data.range(0, 1 / 3) / 3
    }) 



    return <group position={ [-1, -0, 0] } ref={ group } { ...props }>
        <Image
            url={import.meta.env.BASE_URL + 'static/img/old-factory.webp'}
            transparent
            scale={6}
            zoom={0.69}
            segments={4}
            position={[0.2, -0.5, 0]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            colors={colors.clear}
        />

        <Image
            url={import.meta.env.BASE_URL + 'static/img/old-factory-bg.webp'}
            transparent
            scale={7}
            zoom={0.69}
            segments={4}
            position={[0.2, -0.5, -0.55]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />
    </group>
}